module.exports = __webpack_public_path__ + "static/media/clipboard-user.7906bdb0.svg";